module.exports = __webpack_public_path__ + "img/EVENT_CERCA-NEGOZIO_960x256-2-2.118efb78.jpg";